module.exports = __webpack_public_path__ + "static/thumbnail-2ee1c963df3a8eb44dc5f725ac691619.png";